module.exports = __webpack_public_path__ + "img/chinese_takeout.1187a7e4.jpg";